/**
 * Resolves what a picked/listed record should show as text — the picker
 * list's rows (SelectModal) and, when a connect field has `listDisplay` set,
 * the value stored into the display field once something is picked (Connect),
 * so a search list showing "name - number" and the input showing the same
 * thing after picking stay driven by one config, not two.
 *
 * `listDisplay` is either:
 *   - a plain field name (string), or
 *   - a template: { text: '${1} - ${2}', params: ['name', 'number'] }
 * Falls back to `menuItemField`, then `name`, then `id`.
 */
const resolveDisplay = (item, menuItemField, listDisplay) => {
    if (listDisplay) {
        if (typeof listDisplay === 'string') return item[listDisplay] ?? item.name ?? item.id ?? '';
        if (listDisplay.text && Array.isArray(listDisplay.params)) {
            return listDisplay.params.reduce(
                (str, field, i) => str.replace(`\${${i + 1}}`, item[field] ?? ''),
                listDisplay.text
            );
        }
    }
    return item[menuItemField] ?? item.name ?? item.id ?? '';
};

export default resolveDisplay
